export enum ButtonType {
  NORMAL = "normal",
  OUTLINE = "outline",
  LINK = "link",
  FAB_ICON ='fab_icon',
  ICON = "icon",
  BASIC = "basic"
}
